import Alert from "@/components/core/alert";
import { Button } from "@/components/core/buttons/button";
import { Form } from "@/components/core/forms/form.tsx";
import { FormControl, FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import { Input } from "@/components/core/forms/input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { useUserPinCodeMutation } from "@/features/dashboard/api/queries/user-queries";
import { type UserPinSchema, userPinSchema } from "@/features/dashboard/types/user";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

export default function PinCodeModal() {
	const { closeModal } = useModalControl();
	const userPinCodeMutation = useUserPinCodeMutation();

	const form = useForm<UserPinSchema>({
		resolver: zodResolver(userPinSchema),
		defaultValues: {
			pin_code: null,
		},
	});

	const handleSubmit = async (values: UserPinSchema) => {
		console.log(values);
		await userPinCodeMutation.mutateAsync(values);
		closeModal();
	};

	useEffect(() => {});

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(handleSubmit)}>
				<div className="grid grid-cols-12 w-full gap-x-3 gap-y-2">
					<div className="flex flex-col w-full col-span-12">
						<FormField
							control={form.control}
							name="pin_code"
							render={({ field }) => (
								<FormItem>
									<div className="flex flex-col w-full">
										<FormLabel required>Pin Code</FormLabel>
										<FormDescription />
									</div>
									<FormGroup>
										<Input autoComplete="off" placeholder="Pin Code" {...field} />
									</FormGroup>
									<FormMessage />
								</FormItem>
							)}
						/>
					</div>
					<div className="flex flex-row justify-between items-center w-full col-span-12 gap-4 mt-2">
						<Button
							className=""
							variant="ghost"
							type="button"
							onClick={() => {
								closeModal();
							}}
						>
							Cancel
						</Button>
						<Button className="">Confirm</Button>
					</div>
				</div>
			</form>
		</Form>
	);
}
